module.exports = __webpack_public_path__ + "img/solvency-green.a5f1430f.svg";